import { BankInfo } from '_gql'

export const isBankInfoPopulated = (bankInfo: Partial<BankInfo> | null | undefined) =>
  !!(
    bankInfo &&
    bankInfo?.bankName &&
    bankInfo?.accountHolderName &&
    bankInfo?.accountNumberLastFour &&
    bankInfo?.routingNumber
  )
